import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";


const initialState = {
	isLoading: false,
	medias: [],
	pagination:null,
	media:null,
	error: null,
	message: null,
};

// Utility functions for reuse
const setPending = (state) => {
	state.isLoading = true;
};

const setRejected = (state, action) => {
	state.isLoading = false;
	state.error = action.payload?.message || 'Something went wrong';

};

const setMediaData = (state, payload) => {
	state.error = null;
	state.isLoading = false;
	state.medias = payload?.data || payload?.media || [];
	state.pagination = payload?.pagination || null;
};

const mediaSlice = createSlice({
	name: "media",
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
		clearMessage: (state) => {
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder
			// Login
			.addCase(updateMedia.pending, setPending)
			.addCase(updateMedia.rejected, setRejected)
			.addCase(updateMedia.fulfilled, (state, action) => {
				state.isLoading = false;
				state.message = action.payload?.message || {type:"info",text:'Media created successfully'};
				state.media = action.payload?.media || null;
			})

			// Get User
			.addCase(fetchFullMedia.pending, setPending)
			.addCase(fetchFullMedia.rejected, setRejected)
			.addCase(fetchFullMedia.fulfilled, (state, action) => {
				state.isLoading = false;

				state.message = action.payload?.message || {type:"info",text:'Media fetched successfully'};
				setMediaData(state, action.payload);
			})
			.addCase(removeBulkMedia.pending, setPending)
			.addCase(removeBulkMedia.rejected, setRejected)
			.addCase(removeBulkMedia.fulfilled, (state, action) => {
				state.isLoading = false;
				state.message = action.payload?.message || {type:"info",text:'Media deleted successfully'};
			})
			.addCase(removeSingleMedia.pending, setPending)
			.addCase(removeSingleMedia.rejected, setRejected)
			.addCase(removeSingleMedia.fulfilled, (state, action) => {
				state.isLoading = false;
				state.message = action.payload?.message || {type:"info",text:'Media deleted successfully'};
			})
	},
});


export const updateMedia = createAsyncThunk("media/update", async (data, { rejectWithValue }) => {
	try {
		const res = await axiosInstance.post(`admin/media/create`, data);
		return res.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || { message: {type:"error",text:"An error occurred"} });
	}
});

export const fetchFullMedia = createAsyncThunk("media/fetch-all", async ({page=1,limit=4}, { rejectWithValue }) => {
	try {
		let url = window.location.href
		let link = url.includes('?') ? `?${url.split("?")[1]}&limit=${limit}&page=${page}` : `?limit=${limit}&page=${page}`;
		const res = await axiosInstance.get(`admin/media/fetch-all${link}`);
		return res.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || { message: {type:"error",text:"An error occurred"} });
	}
});
export const removeSingleMedia = createAsyncThunk("media/remove-single", async (id, { rejectWithValue }) => {
	try {
		const res = await axiosInstance.delete(`admin/media/delete/${id}`);
		return res.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || { message: {type:"error",text:"An error occurred"} });
	}
});
export const removeBulkMedia = createAsyncThunk("media/remove-bulk", async (ids, { rejectWithValue }) => {
	try {
		const res = await axiosInstance.delete(`admin/media/delete-bulk`, { data: { ids } });
		return res.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || { message: {type:"error",text:"An error occurred"} });
	}
});
export const { clearError, clearMessage,clearService } = mediaSlice.actions;
export default mediaSlice.reducer;
